import React from "react";
import useWithStore from "@/Hooks/useWithStore";
import Svg from "@/Components/Svg";
import Checkbox from "@/Components/Checkbox";
import "@/Scss/Components/favoritesCheckbox.scss";

const FavoritesCheckbox = (props) => {
    const {stores = {}, el = {}} = props;
    const {favouritesStore = {}} = stores;
    return (
        <Checkbox
            name={`favoritesHeart`}
            checked={favouritesStore.favouritesData.some((item) => Number(item.id) === Number(el.id))}
            icon={<Svg id={`favouritesHeart`} className={`svg--favouritesHeart`} />}
            checkedIcon={<Svg id={`favouritesHeartActive`} className={`svg--favouritesHeartActive`} />}
            onChange={(e) => favouritesStore.favouritesChange(e, el)}
        />
    );
}

export default useWithStore(FavoritesCheckbox);
